import React from 'react';
import { Outlet } from "react-router-dom";
import Header from './Header';
import Footer from './Footer';
import ScrollToTop from '../components/ScrollToTop';

const UserLayout = () => {

  return (
    <div className="page-wrapper">
      <main className='main-wrapper'>
        <Header/>
        <Outlet /> 
        <ScrollToTop/>
        <Footer/>
      </main>
    </div>
  );
};

export default UserLayout;
